import dayjs, { Dayjs } from 'dayjs';

import { useDataContext } from '../../../context/useDataContext';
import { NoOutage } from '../../../@types/address';

export enum OutageVariant {
  EmptyOutageInfo = 'EmptyOutageInfo',
  NoOutage = 'NoOutage',
  OutagePassed = 'OutagePassed',
  OutageInFuture = 'OutageInFuture',
}

type OutageReturnType =
  | {
      variant: OutageVariant.EmptyOutageInfo | OutageVariant.NoOutage;
    }
  | {
      variant: OutageVariant.OutagePassed | OutageVariant.OutageInFuture;
      dateFrom: Dayjs;
      dateTo: Dayjs;
    };

export function useOutageData(): OutageReturnType {
  const { selectedAddress } = useDataContext();

  const isValidSelectedAddress = !!(selectedAddress?.OutageBegin && selectedAddress?.OutageEnd);
  if (!isValidSelectedAddress) {
    return { variant: OutageVariant.EmptyOutageInfo };
  }

  const { OutageBegin: dateFromString, OutageEnd: dateToString } = selectedAddress;
  // Отсутствие отключений соответствует данному строковому значению
  const noOutageValue: NoOutage = 'без отключения';
  const noOutageRegexp = new RegExp(noOutageValue, 'i');
  const isNoOutageVariant =
    noOutageRegexp.test(dateFromString!) || noOutageRegexp.test(dateToString!);
  if (isNoOutageVariant) {
    return { variant: OutageVariant.NoOutage };
  }

  const dateFrom = dayjs(dateFromString).subtract(3, 'hours').utcOffset(3).set('seconds', 0);
  const dateTo = dayjs(dateToString).subtract(3, 'hours').utcOffset(3).set('seconds', 0);
  const now = dayjs();

  const isOldYear = !dateTo.isSame(now, 'year');
  if (isOldYear) {
    return { variant: OutageVariant.EmptyOutageInfo };
  }

  const isPassed = now.isAfter(dateTo);
  if (isPassed) {
    return { variant: OutageVariant.OutagePassed, dateFrom, dateTo };
  }

  return { variant: OutageVariant.OutageInFuture, dateFrom, dateTo };
}
